import {
  createContext,
  useContext,
  useEffect,
  useState,
} from "react";

import API from "../api/authApi";

const AuthContext = createContext();

export const AuthProvider = ({
  children,
}) => {
  const [user, setUser] =
    useState(null);

  const [hasSchool, setHasSchool] =
    useState(false);

  const [loading, setLoading] =
    useState(true);

  const fetchUser = async () => {
    try {
      const { data } =
        await API.get("/auth/me");

      setUser(data.user);

      setHasSchool(
        data.hasSchool
      );

      return data;
    } catch (error) {
      setUser(null);

      setHasSchool(false);

      return null;
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const logout = async () => {
    try {
      await API.post(
        "/auth/logout"
      );
    } catch (error) {}

    setUser(null);

    setHasSchool(false);
  };

  return (
    <AuthContext.Provider
      value={{
        user,
        hasSchool,
        loading,
        logout,
        refreshUser:
          fetchUser,
        isAuthenticated:
          !!user,
      }}
    >
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () =>
  useContext(AuthContext);